module.exports = __webpack_public_path__ + "img/82ab0613-acf8-4d98-87f6-6b1e5540f5e4.6d1c0022.jpg";